import { Button } from 'edenred-ui';
import styled from 'styled-components';

export const FieldContainer = styled.div`
  padding-bottom: 35px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: end;
  padding-right: 40px;
`;

export const StyledButton = styled(Button)`
  width: 135px;
`;

export const ActionsContainer = styled.div<{ isMobile: boolean }>`
  position: absolute;
  z-index: 1;
  top: ${({ isMobile }) => (isMobile ? '0' : '30px')};
  right: ${({ isMobile }) => (isMobile ? '0' : '60px')};
  bottom: ${({ isMobile }) => (isMobile ? '100%' : 'auto')};
  display: flex;
  gap: 8px;
`;
